import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { SessionUserSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { updateLocalGroupsLicenseUponLogin } from '../actions/GroupMenuActions';
import { IGroupInfo } from '../models/IGroupInfo';

export const GroupUpdateGrantLicenseModeAction: IEntityAction<IGroupInfo, {}> = {
  name: EntityActionNames.UpdateGroupGrantLicenseMode,
  translateName: Messages.licenseUponLogin,
  isVisible: (targetItems: IGroupInfo[], state: AppState) => {
    const isGroupsSpace = state.spaceInfo.spaceType === 'groups';
    const isVisibleWithLUL = hasLocalGroupsOnly(targetItems);
    if (FeatureFlags.editGroupRedesignEnabled  && targetItems.length === 1 && isLocalGroup(targetItems[0])
      && !targetItems[0].isAllUsersGroup) {
      return false;
    }
    return targetItems.length >= 1
      && isVisibleWithLUL
      && isGroupsSpace;
  },
  isClickable: (availableActions: {}, targetItems: IGroupInfo[], state: AppState) => SessionUserSelectors.canManageUsers(state),
  createReduxAction: (targetItems: IGroupInfo[]) => updateLocalGroupsLicenseUponLogin(targetItems)
};

function hasLocalGroupsOnly(groups: IGroupInfo[]): boolean {
  const result = groups.filter(group => isLocalGroup(group)).length;
  return result === groups.length;
}

function isLocalGroup(group: IGroupInfo): boolean {
  return (group.domainName === undefined || group.domainName === 'local');
}
